import PronosticoMalezas from 'components/PronosticoMalezas'

export default PronosticoMalezas
